import { darkTheme, lightTheme } from "./theme.mjs";
import { TextStylesProvider } from "./Text.mjs";
import { PurseProvider } from "purse-styles";
import React, { useEffect, useMemo, useState } from "react";
import { match } from "@repo/utils/utils";
import { createNamedContext, useRequiredContext } from "@repo/utils/hooks/useRequiredContext";
import { jsx } from "react/jsx-runtime";

//#region src/ThemeProvider.tsx
const ThemeContext = createNamedContext("ThemeContext", void 0);
function useTheme() {
	return useRequiredContext(ThemeContext);
}
function ThemeProvider({ children, forceMode }) {
	const mediaQuery = useMemo(() => {
		return window.matchMedia("(prefers-color-scheme: dark)");
	}, []);
	const [resolvedMode, setResolvedMode] = useState(forceMode ?? (mediaQuery.matches ? "dark" : "light"));
	useEffect(() => {
		if (forceMode) return;
		const apply = (e) => {
			setResolvedMode(e.matches ? "dark" : "light");
		};
		mediaQuery.addEventListener("change", apply);
		return () => mediaQuery.removeEventListener("change", apply);
	}, [mediaQuery, forceMode]);
	const theme = resolvedMode === "light" ? lightTheme : darkTheme;
	return /* @__PURE__ */ jsx(PurseProvider, { children: /* @__PURE__ */ jsx(ThemeContext.Provider, {
		value: theme,
		children: /* @__PURE__ */ jsx(TextStylesProvider, { children })
	}) });
}
function ThemeOverride({ children, mode }) {
	const baseTheme = useTheme();
	const theme = mode ? match(mode, {
		flip: baseTheme.name === "light" ? darkTheme : lightTheme,
		light: lightTheme,
		dark: darkTheme
	}) : baseTheme;
	return /* @__PURE__ */ jsx(ThemeContext.Provider, {
		value: theme,
		children
	});
}

//#endregion
export { ThemeOverride, ThemeProvider, useTheme };